import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonLoader = ({ style = {}, className = "", containerClassName = "" }) => {
 
  const defaultStyle = {
    backgroundColor: '#f0f2f5',
    backgroundImage: 'linear-gradient(90deg, #f0f2f5 0%, #e4e6eb 50%, #f0f2f5 100%)',
    backgroundSize: '200% 100%',
    backgroundRepeat: 'no-repeat',
    animation: 'shimmer 1.2s infinite linear',
    ...style,
  };

  return (
    <Skeleton
      className={`w-full h-64 rounded-md overflow-hidden ${className}`}
      containerClassName={containerClassName}
      style={defaultStyle}
    />
  );
};

export default SkeletonLoader;
